export const uboxlist = [
  {
    list: "1",
    name: "กล่องเปล่า ไม่ได้รับรางวัล",
    pc: "26.32 %",
  },
  {
    list: "2",
    name: "20 uDiamond",
    pc: "26.32 %",
  },
  {
    list: "3",
    name: "50 uDiamond",
    pc: "26.32 %",
  },
  {
    list: "4",
    name: "100 uDiamond",
    pc: "13.16 %",
  },
  {
    list: "5",
    name: "200 uDiamond",
    pc: "6.58 %",
  },
  {
    list: "6",
    name: "1,000 uDiamond",
    pc: "1.05 %",
  },
  {
    list: "7",
    name: "รางวัลเครดิตเงินจริง 10 เครดิต",
    pc: "0.13 %",
  },
  {
    list: "8",
    name: "รางวัลเครดิตเงินจริง 20 เครดิต",
    pc: "0.06 %",
  },
  {
    list: "9",
    name: "รางวัลใหญ่ 1,000 เครดิต",
    pc: "0.03%",
  },
];

export const wheels = [
  {
    list: "ของรางวัลที่ - 1",
    name: "ไม่ได้รับรางวัล",
    pc: "30 %",
  },
  {
    list: "ของรางวัลที่ - 2",
    name: "20 uDiamond",
    pc: "30 %",
  },
  {
    list: "ของรางวัลที่ - 3",
    name: "50 uDiamond",
    pc: "20 %",
  },
  {
    list: "ของรางวัลที่ - 4",
    name: "100 uDiamond",
    pc: "10 %",
  },
  {
    list: "ของรางวัลที่ - 5",
    name: "500 uDiamond",
    pc: "5 %",
  },
  {
    list: "ของรางวัลที่ - 6",
    name: "1,000 uDiamond",
    pc: "4.99 %",
  },
  {
    list: "ของรางวัลที่ - 7 รางวัลใหญ่",
    name: "iPhone 13 Pro (256 GB)",
    pc: "0.01 %",
  },
];

export const merrychrismas = [
  {
    list: "ของรางวัลที่ - 1",
    name: "ทองคำหนัก 1 บาท",
    pc: "12 / 12 รางวัล",
  },
  {
    list: "ของรางวัลที่ - 2",
    name: "iPad Pro 2021 12.9 นิ้ว 128GB",
    pc: "5 / 5 รางวัล",
  },
  {
    list: "ของรางวัลที่ - 3",
    name: "รถมอเตอร์ไซค์ PCX 150cc",
    pc: "3 / 3 รางวัล",
  },
];

export const rewardxmas = [
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 1",
    name: "min-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 2",
    name: "Par-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 3",
    name: "the-xxx",
    pc: "ได้รับ iPad Pro 2021 12.9 นิ้ว 128GB",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 4",
    name: "fli-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 5",
    name: "naw-xxx",
    pc: "ได้รับ PCX 150cc",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 6",
    name: "pat-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 7",
    name: "new-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 8",
    name: "pon-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 9",
    name: "arc-xxx",
    pc: "ได้รับ iPad Pro 2021 12.9 นิ้ว 128GB",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 10",
    name: "vee-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 11",
    name: "kor-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 12",
    name: "maw-xxx",
    pc: "ได้รับ iPad Pro 2021 12.9 นิ้ว 128GB",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 13",
    name: "noo-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 14",
    name: "pre-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 15",
    name: "miw-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 16",
    name: "pin-xxx",
    pc: "ได้รับ ทองคำมูลค่า 1 บาท",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 17",
    name: "mon-xxx",
    pc: "ได้รับ PCX 150cc",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 18",
    name: "nam-xxx",
    pc: "ได้รับ iPad Pro 2021 12.9 นิ้ว 128GB",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 19",
    name: "vee-xxx",
    pc: "ได้รับ iPad Pro 2021 12.9 นิ้ว 128GB",
  },
  {
    list: "ผู้โชคดีที่ได้รับรางวัลคนที่ - 20",
    name: "nac-xxx",
    pc: "ได้รับ PCX 150cc",
  },
];

export const luckyuser = [
  {
    list: "ได้รับ iPhone 13 Pro 256 GB",
    time: "2021.08.22 14:09:46",
    name: "1 - ผู้โชคดีที่ได้รับรางวัล คุณ War-xxx",
  },
  {
    list: "ได้รับ iPhone 13 Pro 256 GB",
    time: "2021.08.22 14:09:46",
    name: "2 - ผู้โชคดีที่ได้รับรางวัล คุณ War-xxx",
  },
  {
    list: "ได้รับ iPhone 13 Pro 256 GB",
    time: "2021.08.22 14:09:46",
    name: "3 - ผู้โชคดีที่ได้รับรางวัล คุณ War-xxx",
  },
];
